// useMySelectors.ts
import { useSelector } from "react-redux";
var useSelectors = function () {
    var _a = useSelector(function (state) { return ({
        responsePlan: state.Plan.responsePlan,
        errorPlan: state.Plan.errorPlan,
        loading: state.Plan.loadingPlan,
    }); }), responsePlan = _a.responsePlan, errorPlan = _a.errorPlan, loading = _a.loading;
    var responseCampaign = useSelector(function (state) { return ({
        responseCampaign: state.Campaign.responseCampaign,
    }); }).responseCampaign;
    var _b = useSelector(function (state) { return ({
        responseCountries: state.Countries.responseCountries,
        errorCountries: state.Countries.errorCountries,
        loadingCountries: state.Countries.loadingCountries,
    }); }), responseCountries = _b.responseCountries, errorCountries = _b.errorCountries, loadingCountries = _b.loadingCountries;
    var _c = useSelector(function (state) { return ({
        responseRegion: state.Region.responseRegion,
        errorRegion: state.Region.errorRegion,
        loadingRegion: state.Region.loadingRegion,
    }); }), responseRegion = _c.responseRegion, errorRegion = _c.errorRegion, loadingRegion = _c.loadingRegion;
    var _d = useSelector(function (state) { return ({
        responseQuote: state.Quote.responseQuote,
        errorQuote: state.Quote.errorQuote,
        loadingQuote: state.Quote.loadingQuote,
    }); }), responseQuote = _d.responseQuote, errorQuote = _d.errorQuote, loadingQuote = _d.loadingQuote;
    var _e = useSelector(function (state) { return ({
        responsePerson: state.Person.responsePerson,
        errorPerson: state.Person.errorPerson,
        loadingPerson: state.Person.loadingPerson,
    }); }), responsePerson = _e.responsePerson, errorPerson = _e.errorPerson, loadingPerson = _e.loadingPerson;
    var _f = useSelector(function (state) {
        var _a;
        return ({
            responsePlans: (_a = state.Plans.responsePlans) === null || _a === void 0 ? void 0 : _a.data,
            errorPlans: state.Plans.errorPlans,
            loadingPlans: state.Plans.loadingPlans,
        });
    }), responsePlans = _f.responsePlans, errorPlans = _f.errorPlans, loadingPlans = _f.loadingPlans;
    var _g = useSelector(function (state) { return ({
        responseCatalogGender: state.Plan.responseCatalogGender,
        errorCatalogGender: state.Plan.errorCatalogGender,
    }); }), responseCatalogGender = _g.responseCatalogGender, errorCatalogGender = _g.errorCatalogGender;
    return {
        responsePlan: responsePlan,
        errorPlan: errorPlan,
        loading: loading,
        responseCampaign: responseCampaign,
        responseCountries: responseCountries,
        errorCountries: errorCountries,
        loadingCountries: loadingCountries,
        responseRegion: responseRegion,
        errorRegion: errorRegion,
        loadingRegion: loadingRegion,
        responseQuote: responseQuote,
        errorQuote: errorQuote,
        loadingQuote: loadingQuote,
        responsePerson: responsePerson,
        errorPerson: errorPerson,
        loadingPerson: loadingPerson,
        responsePlans: responsePlans,
        errorPlans: errorPlans,
        loadingPlans: loadingPlans,
        responseCatalogGender: responseCatalogGender,
        errorCatalogGender: errorCatalogGender,
    };
};
export default useSelectors;
